import { openDialog, WebDialog } from "web-dialog";
import { html, render } from "lit";
import { EVENT_LIGHT_BOX_OPEN, Media, Ref } from "shared";
import { eventService } from "../services/event-service";

export async function openLightBox({
	attachments = [],
	index = 0,
	deleteCallback,
	updateCallback,
	canEdit
}: {
	attachments: Ref<Media>[];
	index: number;
	deleteCallback?: (media: Ref<Media>) => Promise<boolean | undefined>;
	updateCallback?: (media: Ref<Media>, index: number) => Promise<void>;
	canEdit?: boolean;
}) {
	import("../atoms/light-box");
	eventService.trackEvent(EVENT_LIGHT_BOX_OPEN);

	return await openDialog<WebDialog>({
		initialize: () => {
			const $d = new WebDialog();
			$d.style.setProperty("--dialog-max-width", "1200px");
			$d.style.setProperty("--dialog-padding", "0");
			return $d;
		},
		$content: ($dialog) =>
			render(
				html`
					<bs-light-box
						.attachments=${attachments}
						index="${index}"
						@close="${() => $dialog.close()}"
						?can-edit="${canEdit}"
						.deleteCallback="${deleteCallback}"
						.updateCallback="${updateCallback}"
					></bs-light-box>
				`,
				$dialog
			)
	}).resolver;
}
